import React, { useContext } from 'react';
import { Modal } from "react-bootstrap";
import { TranslationContext } from "../../contexts/TranslationContext";
import { IUserSearchResult, IUserSolution } from "../../services/WebApiClient";
import { UserSolutionTable } from '../CabinetList/UserSolutionTable';


export function UserModal(props: {
    user: IUserSearchResult;
    onClose: () => void;
    orderChanged: () => void;
    onOrderComplete: (us: IUserSolution) => void;
}) {

    const tc = useContext(TranslationContext);

    return (
        <Modal onHide={props.onClose}
            show
            animation={false}
            centered
            scrollable
            size="lg"
        >
            <Modal.Header
                closeButton
                closeLabel={tc.translator("modal close label", "Luk")} >
                <Modal.Title>
                    { props.user.name }
                </Modal.Title>

            </Modal.Header>
            <Modal.Body>
                {props.user.solutions.length > 0
                    ? <UserSolutionTable userSolutions={props.user.solutions}
                        orderChanged={props.orderChanged}
                        onOrderComplete={props.onOrderComplete} />
                    : <h4>{tc.translator("user modal no solutions text", "Ingen løsninger")}</h4>
                }
                
            </Modal.Body>

            <Modal.Footer>
                <button type="button" className="btn btn-outline-primary"
                    onClick={() => props.onClose()}>
                    {tc.translator("modal close label", "Luk")}
                </button>
            </Modal.Footer>
        </Modal>

        );
}
